{
  "dirty": false,
  "raw": "ca1d875",
  "hash": "ca1d875",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "ca1d875",
  "semverString": null,
  "buildDate": "2026-04-23T09:50:31.309Z"
}